module.exports = __webpack_public_path__ + "img/asian.e1a53052.jpeg";